

<template>
    <div>
        <div class="row">
            <div class="col-md-4">{{parentItemName}}{{snapshot.propertyName}}</div>
            <div class="col-md-4">{{snapshot.oldValue}}</div>
            <div class="col-md-4">{{snapshot.currentValue}}</div>
        </div>
       
    </div>
</template>

<style scoped>
    .snapshot-details {
        margin-left: 25px;
        margin-bottom: 5px;
    }

    .key-style {
        font-weight: 400;
    }
</style>

<script type="text/babel">
    export default {
    props: {
    "snapshot": {default: null},
    "parentItemName":{default:null}
    }
    }
</script>